import { render, staticRenderFns } from "./sharedCustomer.vue?vue&type=template&id=2917d02a&"
import script from "./sharedCustomer.vue?vue&type=script&lang=js&"
export * from "./sharedCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports